export default "__VITE_ASSET__DjoGZgOB__"